export type PageLoadStartedInfo = {
  name         : string,
  geoRegion    : string,
  [key: string]: unknown
};

export type PageLoadStartedAttributes = Partial<{
  promotionID        : string,
  internalPromotionID: string,
  trackingID         : string
  [key: string]      : unknown
}>;

export type PageLoadStartedCompletePageObject = {
  info: {
    name            : string,
    section         : string,
    subSection      : string,
    subSubSection   : string,
    subSubSubSection: string,
    destinationURL  : string,
    queryString     : string,
    referringURL    : string,
    serverName      : string,
    sysEnv          : string,
    language        : `${string}-${string}`,
    geoRegion       : string,
    [key: string]   : unknown
  },
  attributes: {
    internalPromotionID: string,
    trackingID         : string,
    time               : string,
    date               : string,
    domain             : string,
    domainPeriod       : number,
    ppvScrollData      : string,
    ppvName            : string,
    [key: string]      : unknown
  }
}